const serviceCards = [
  {
    id: 1,
    title: "Clarity in Every Trade",
    description:
      " We believe understanding the market is the first step to mastering it. Our platform is built to make every trade clear and every decision informed.",
  },
  {
    id: 2,
    title: "Trust Through Transparency",
    description:
      "Integrity is at the heart of everything we do, from our pricing to our policies. We strive to earn and maintain your trust through every interaction.",
  },
  {
    id: 3,
    title: "Empowerment Through Education",
    description:
      "We’re passionate about helping beginners transform into confident traders. Learning is not just an option at The Pips, it’s our foundation.",
  },
  {
    id: 4,
    title: "Innovation That Inspires",
    description:
      "We embrace technology that makes trading smarter, safer, and more intuitive, ensuring every trader has the tools to succeed.",
  },
  {
    id: 5,
    title: "Community That Connects",
    description:
      "Behind every trade is a human story. We’re proud to build a community where support, growth, and collaboration thrive.",
  },
  {
    id: 6,
    title: "Excellence Through Experience",
    description:
      "We continuously refine our platform and services through real market insights and user feedback, ensuring that every trader, beginner or expert, experiences the highest standard of performance, reliability, and support.",
  },
];

const QualityProcessSection = () => {
  return (
    <section className="quality-section-about">
      <div className="quality-header-about">
        <h1>Our Values</h1>
        <p>
          We are committed to redefine how the world learns, trades, and
          invests, creating a space where anyone can grow with confidence and
          clarity. We are here to make trading simple, transparent, and
          rewarding through education, innovation, and community-driven support.
        </p>
      </div>

      <div className="container">
        <table className="quality-table">
          <tbody>
            {serviceCards
              .reduce((rows, card, index) => {
                if (index % 2 === 0) rows.push([card]);
                else rows[rows.length - 1].push(card);
                return rows;
              }, [])
              .map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((card) => (
                    <td key={card.id}>
                      <h3>{card.title}</h3>
                      <p>{card.description}</p>
                    </td>
                  ))}
                  {row.length < 2 && <td></td>} {/* for even layout */}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default QualityProcessSection;
